import BlockAmbassadorImg from './BlockAmbassadorImg';
export default BlockAmbassadorImg;
